import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

let state = {
    loading: 0,
    screenWidth: null,
    user: null,
    errors: [],
    messages: [],
    warnings: [],
    webp: '',
    active: {},
    data: null,
    seo: {},
    serverFetched: false,
    mobile: false,
    location: {}  
};

export default function createStore() {
    return new Vuex.Store({
        state: () => state
    })
};